import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface GenericConfirmationModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  onConfirm: () => void;
  isLoading?: boolean;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmButtonColor?: 'primary' | 'error' | 'success';
}

function GenericConfirmationModal({
  isOpen,
  title,
  description,
  onConfirm,
  onCancel,
  isLoading = false,
  confirmText = 'Aceptar',
  cancelText = 'Cancelar',
  confirmButtonColor = 'success',
}: GenericConfirmationModalProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{description}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          padding: 2,
        }}
      >
        <Button onClick={onCancel} color="primary" disabled={isLoading}>
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmButtonColor}
          variant="contained"
          loading={isLoading}
          disabled={isLoading}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default GenericConfirmationModal;
